import { FormProvider, useForm } from "react-hook-form";

import ModalOutlet from "@/components/modals/router/ModalOutlet";

import { ResetPasswordForm } from "../modal/SetNewPassword";

const AuthModalWrap = () => {
  const formMethods = useForm<ResetPasswordForm>({ reValidateMode: "onSubmit" });

  return (
    <div className="max-w-[32rem]">
      <FormProvider {...formMethods}>
        <ModalOutlet />
      </FormProvider>
    </div>
  );
};

export default AuthModalWrap;
